import AssetListItem from '@/shared/components/AssetListItem/AssetListItem';
import { AssetBalances } from '@/types/balances';
import { IonGrid, IonItem } from '@ionic/react';
import { EntityId } from '@reduxjs/toolkit';
import styles from './AssetList.module.css';
import { useWindowDimensions } from '@/shared/hooks/useWindowDimension';
import { TravelRuleType, withdrawCryptoState } from '@/types/crypto';
import { useCallback } from 'react';

type Props = {
  selectedAsset?: EntityId;
  assetsPortfolioBalances: AssetBalances;
  handleInitTravelRule: (value: boolean, withdrawCryptoData: withdrawCryptoState, type?: TravelRuleType) => void;
};

const AssetList: React.FC<Props> = ({ selectedAsset, assetsPortfolioBalances, handleInitTravelRule }) => {
  const { isMobileView } = useWindowDimensions();

  const currentAsset = selectedAsset ?? assetsPortfolioBalances[0]?.assetId;

  const clearTravelRule = useCallback(() => {
    const resetTravelRule = (type) => {
      handleInitTravelRule(false, { id: null, intentId: null }, type);
    };

    const travelRuleType = [TravelRuleType.Withdrawal, TravelRuleType.Deposit];
    travelRuleType.forEach(resetTravelRule);
  }, [handleInitTravelRule]);

  return (
    <>
      {assetsPortfolioBalances &&
        assetsPortfolioBalances.map((assetBalance) => (
          <IonItem
            key={assetBalance.assetId}
            lines="none"
            className={`ion-no-padding ${styles.listWrapper} ${
              isMobileView ? styles.itemWrapperMobile : styles.itemWrapper
            } ${currentAsset === assetBalance.assetId && !isMobileView ? styles.itemActive : ''}`}
            routerLink={`/wallets/${assetBalance.assetId}`}
            onClick={clearTravelRule}
          >
            <IonGrid className={`${styles.itemContainer}`}>
              <AssetListItem assetBalance={assetBalance} />
            </IonGrid>
          </IonItem>
        ))}
    </>
  );
};

export default AssetList;
